export default 'DUCKS/GOOGLE';
